export const AnalyticsLocalStorageKeys = {
  RefContextType: 'ref_ctx_type',
  RefContextIndex: 'ref_ctx_index',
  RefContextLabel: 'ref_ctx_label',
  RefListID: 'ref_list_id',
  RefListIndex: 'ref_list_index'
};

export const AnalyticsItemsList = {
  SearchResultsPageResults: 'srp_results',
  ProductFeed: 'product_feed',
  FanArtCarousel: 'fan_art_carousel',
  RecommendedWorksCarousel: 'recommended_works_carousel',
  RecommendedWorksPreviewCarousel: 'recommended_works_preview_carousel',
  RecentlyViewedCarousel: 'recently_viewed_carousel',
  TopicProductCarousel: 'topic_product_carousel',
  ExploreFeed: 'explore_feed',
  ExploreFollowFeed: 'explore_follow_feed'
};

export const AnalyticsItemsListIDNameMap = {
  srp_results: 'SRP Results',
  product_feed: 'Product Feed',
  recommended_works_carousel: 'Recommended Works Carousel',
  recently_viewed_carousel: 'Recently Viewed Carousel',
  recommended_works_preview_carousel: 'Recommended Works Preview Carousel',
  topic_product_carousel: 'Topic Product Carousel',
  fan_art_carousel: 'Fan Art Carousel',
  explore_feed: 'Explore Feed',
  explore_follow_feed: 'Explore Follow Feed'
};

export const AnalyticsContextTypes = {
  TrendingTypeahead: 'trending-typeahead',
  PopularTypeahead: 'popular-typeahead',
  RecentTypeahead: 'recent-typeahead',
  FallbackTypeahead: 'fallback-typeahead',
  CategoriesTypeahead: 'categories-typeahead',
  ArtistsTypeahead: 'artists-typeahead',
  SearchBox: 'search-box'
};
